(function Module() {
	'use strict';
	const {log,mySynchModules} = require('../globals');

	var config = mySynchModules.config;
	mySynch.controller('Fertility360ReportController', [
		'$scope',
		'$rootScope',
		'ApiFactory',
		'AuditService',
		'F360Constant',
		'MySynchFactory',
		'$filter',
	    '$q',
		'ViewAuthorizationFactory',
		'mySynchEnumerationService',
		'performanceMetricsService',
		'performanceContextService',
		function Fertility360ReportController($s,$rootScope, api, audit, constant, MSF,$filter,$q,viewAuth,mySynchEnumSvc,perfMetricSvc, perfContextSvc) {
			var self = this;
			self.lact1 = null;
			self.lact2 = null;
			self.listReport = [];
			self.personId = MSF.cookies.user.PersonId;
			self.disableStartNewEvaluation = false;
			$s.isOnline = $rootScope.onLine;
			self.notShowStartNewEvaluationSection = false;
			self.enableVwpChanging = false;				// this user story is incomplete and is postponed
			$s.mySynchState = {};
			$s.activeFarm = {};
			$s.currentHerd = {};
			$s.activeAudit = undefined;
			$s.performanceContext  = null;

			
			
            $s.territoryManager = MSF.getActiveFarmTerritoryManager(); 

			$s.validEditAuditRoles = [
				mySynchEnumSvc.getMySynchEnumeration('Role','SUPER_ADMIN'),
				mySynchEnumSvc.getMySynchEnumeration('Role','TERRITORY_MANAGER'),
				mySynchEnumSvc.getMySynchEnumeration('Role','ADMIN')
			];
			
			$s.canCreateAndEditAudits = false;

			$s.herdFertilityProgramLoaded = false;
			$s.listLoaded = false;
			$s.currentHerdLoaded = false;
			$s.pageLoaded = false;
			$s.checkSyncInterval = constant.initialCheckF360SyncInterval;

			//temp flag that needs to be removed later after a bug when a 2nd device tries to edit an active audit that hasn't started to answer questions
			$s.canEdit = true;
			$s.deviceUpdateNeeded = false;

			$s.prePopulatedDataOutOfDate = false;
			$s.numDaysPrePopulatedDataOld = "";
			$s.latestReportDate = null; 


			$s.codeFile = [];


			$s.currentAuditApiVersion;

			// watcher degresigration variables
			var deregOnFarmChange = undefined;
			var deregOnHerdChange = undefined;
			var deregPageLoad = undefined;
			var deregObjectStoresInitialized = undefined;
            var deregOnlineCheckWatch = undefined;
			   // flag for that is set true when the delete call occurs successfuly without updating the server
			   $s.isDirty = false;
			   $s.syncInProgress = false;

			   // flag for create audit button spinner 
			   $s.loading = false;

			
			
			$s.formatDateString = function(dateTimeString){
			    var dateFormat = MSF.getActiveHerdTimeFormatWithLongDigitYear();
				return moment(dateTimeString).format(dateFormat);

			};
			
			
			function loadCurrentHerd(){
				   $s.currentHerdLoaded = false;
				audit.getHerdsByFarmId(_.get($s.activeFarm,'farmId'), function getF360HerdsByFarmId(err, herd){
					  if (err) {
						  console.log('err', err);
					  }else{
						  $s.currentHerd =  herd[0];
						  $s.currentHerdLoaded = true;

						  if (!$s.isOnline) {
                             $s.$apply($s.currentHerdLoaded); 
						  }
						 
					  }       
				});

			 
		  }
		  function loadCurrentFarm(){
			var mySynchStateJSON = localStorage.getItem('MySynch-state');
			if(!_.isUndefined(mySynchStateJSON)){
				$s.mySynchState = JSON.parse(mySynchStateJSON);

				$s.activeFarm = _.get($s.mySynchState,'value.activeFarm',{});
			}
		  }
			function checkPermissions(){
				if(viewAuth.hasRole(mySynchEnumSvc.getMySynchEnumeration('Role','SUPER_ADMIN')) 
				|| viewAuth.hasRole(mySynchEnumSvc.getMySynchEnumeration('Role','TERRITORY_MANAGER')) 
				|| viewAuth.hasRole(mySynchEnumSvc.getMySynchEnumeration('Role','ADMIN'))
				){
					$s.canCreateAndEditAudits = true;
				}
				
			}

			function checkPrePopulatedDataStatus(){
				$s.latestReportDate = moment(_.get(MSF.getActiveHerd(),'latestReportDate',null));
				if(_.isEqual($s.latestReportDate,"")){
					$s.latestReportDate = null;
				}
				if(!_.isUndefined($s.latestReportDate) && !_.isNull($s.latestReportDate) && !_.isEqual($s.latestReportDate,"")){
				   
					var currentDateObj = moment();
					var adjustedLatestReportDate = moment($s.latestReportDate).subtract(moment($s.latestReportDate).utcOffset(), 'minutes');

					$s.numDaysPrePopulatedDataOld = Math.abs(currentDateObj.diff(adjustedLatestReportDate,'days'));

					if($s.numDaysPrePopulatedDataOld > 14){
						$s.prePopulatedDataOutOfDate = false;
					}else{
						$s.prePopulatedDataOutOfDate = false;
					}


				}else{
					$s.prePopulatedDataOutOfDate = true;
				}
			}

			function getHerdFertilityProgramsByHerdId() {
				const getHerdFertilityProgramsByHerdIdPromise = $q.defer();
				$s.herdFertilityProgramLoaded = false;
				perfMetricSvc.startTiming('Page:Fertility360ReportGetHerdFertilityProgramsByHerdId:Request');
				audit.getHerdFertilityProgramsByHerdId($s.performanceContext, function programsGotten(err, program) {
					perfMetricSvc.endTiming("page",'Page:Fertility360ReportGetHerdFertilityProgramsByHerdId:Request', $s.performanceContext);
					if (err) {
						log.error('error getting F360 online check: ' + err);
					}
					if (program) {
						MSF.setActiveHerdFertilityProgram(program);

						var activeHerdFertilityProgram = MSF.getActiveHerdFertilityProgram();
						self.lact1 = activeHerdFertilityProgram ? activeHerdFertilityProgram.lactation1VoluntaryWithholdPeriod : constant.lactDefault1;
						self.lact2 = activeHerdFertilityProgram ? activeHerdFertilityProgram.lactation2VoluntaryWithholdPeriod : constant.lactDefault2;
						
					}
					
					$s.herdFertilityProgramLoaded = true;

					if (!$s.isOnline) {
                        $s.$apply($s.herdFertilityProgramLoaded);
					}
					getHerdFertilityProgramsByHerdIdPromise.resolve();
				});
				return getHerdFertilityProgramsByHerdIdPromise.promise;
			}

			function getCheckedOutToDisplay(checkedOutTo) {
				var checkedOutToDisplay = "";
				if (!_.isEmpty(checkedOutTo) && !_.isNull(checkedOutTo)) {
					checkedOutToDisplay = checkedOutTo.FirstName + " " + checkedOutTo.LastName;
				}
				return checkedOutToDisplay;
			}

			function getAuthorsDisplay(authors) {
				var authorsDisplay = "";
				if (!_.isEmpty(authors) && !_.isNull(authors)) {
					if(authors.length > 1){
					_.forEach(authors, function (author,index,authorsArray) {
						if(index == authorsArray.length - 1){
							authorsDisplay += author.FirstName + " " + author.LastName;
						}else{
							authorsDisplay += author.FirstName + " " + author.LastName + ", ";
						}
					});
				  }else{
					authorsDisplay = authors[0].FirstName + " " + authors[0].LastName;
				  }
				}
				return authorsDisplay;
			}

			function loadReportData() {
				
				const loadReportDataPromise = $q.defer();

				$s.listLoaded = false;
				perfMetricSvc.startTiming('Page:Fertility360ReportGetListByHerdId:Request');
				audit.getListByHerdId($s.performanceContext, function getF360ListByHerdId(err, data) {
					perfMetricSvc.endTiming("page",'Page:Fertility360ReportGetListByHerdId:Request', $s.performanceContext);
					if (err) {
						log.error('error getting F360 online check: ' + err);
					}
					perfMetricSvc.startTiming('Page:Fertility360Report:Build');

					if (data && data.length > 0) {
						self.listReport = data;
						var auditNotPublished = data.filter(item => !item.PublishedOn);
						if (auditNotPublished.length > 0) {
							self.disableStartNewEvaluation = true;
						}
						var auditInProgress = data.filter(item => !item.PublishedOn);
						if (auditInProgress.length > 0) {
							self.notShowStartNewEvaluationSection = true;
						}
						else {
							self.notShowStartNewEvaluationSection = false;
							self.disableStartNewEvaluation = false;
						}
						// grab the active audit and have the audit service check to see if the object store record needs 
						// its display fields like CheckedOutTo and Authors properties updated
                         var activeAudit = _.find(_.sortByOrder(self.listReport,['AuditId'],['desc']),function(auditListItem){
							                  var publishedOn = _.get(auditListItem,'PublishedOn');
							                  return _.isUndefined(publishedOn) || _.isNull(publishedOn);
										    });
						// we need to update the cached display fields for the active audit if it has been changed manually in sql or this is a different device 
						audit.updateCachedAuditDisplayFields(activeAudit);
						  
						// we need to parse the JSON strings for CheckedOutTo and Authors
						self.listReport = _.map(self.listReport, function (item) {
							var checkedOutToJSON = _.get(item, 'CheckedOutTo',null);
							var authorsJSON = _.get(item, 'Authors', null);
							var checkedOutTo = {};
							var authors = [];
							var checkedOutToDisplay = "";
							var authorsDisplay = "";
							if(!_.isNull(checkedOutToJSON)){
								try {
									checkedOutTo = JSON.parse(checkedOutToJSON);
								} catch (error) { console.log(`error parsing checkedOutTo JSON: ${error}`); }
							}
							if(!_.isNull(authorsJSON)){
								try {
									authors = JSON.parse(authorsJSON);
								} catch (error) { console.log(`error parsing authors JSON: ${error}`); }
							}
							_.set(item, 'CheckedOutTo', checkedOutTo);
							_.set(item, 'CheckedOutToDisplay', getCheckedOutToDisplay(checkedOutTo));
							_.set(item, 'Authors', authors);
							_.set(item, 'AuthorsDisplay', getAuthorsDisplay(authors));
							return item;
						});	
							
							
                        // we want to set activeAudit if an audit hasn't been published yet or has been published offline ( where IsDeviceDirty would be true) and if the audit in progress wasn't deleted. 
						$s.activeAudit = _.find(self.listReport,function(auditListItem){
							return  ((_.isNull(_.get(auditListItem,'PublishedOn',null)) || (!_.isNull(_.get(auditListItem,'PublishedOn',null)) && _.isEqual(_.get(auditListItem,'IsDeviceDirty'),true))) && _.isEqual(_.get(auditListItem,'Deleted',false),false));
							} );
						
					}
					else {
						self.listReport = [];
						self.disableStartNewEvaluation = false;
						self.notShowStartNewEvaluationSection = false;
					}

				
				
					$s.listLoaded = true;
					if (!$s.isOnline) {
						self.listReport = _.sortByOrder(self.listReport,['AuditId'],['desc']);
						$s.$apply($s.listLoaded);
					
					}
					$s.syncInProgress = true;
					$s.checkF360SyncStatus().then(function(){
						$s.syncInProgress = false;
						perfMetricSvc.endTiming("page",'Page:Fertility360Report:Build', $s.performanceContext);
						loadReportDataPromise.resolve();
					});
				});
				return loadReportDataPromise.promise;
			}
			$s.toggleModal = function (modalId) {                
                var modal = $('#' + modalId);
                if (_.isUndefined(modal[0]) || !modal[0]) return;

                if (modal.is(':visible')) {
                    modal.css("display", "none");
                } else {
                    modal.css("display", "block");
                }
            };
			$s.onConfirmDeleteAudit = function onConfirmDeleteAudit(auditId) 
			{
				
			}
			$s.downloadAndStart = function downloadAndStart() {
				if ($s.isOnline) {
				  if(!$s.loading){	
					$s.loading = true;
					var currentHerd = MSF.getActiveHerd();
					audit.createNewAudit($s.currentAuditApiVersion,currentHerd.herdId, self.personId, self.lact1, self.lact2, function getIpAddress(err, data) {
						if (err) {
							log.error('error getting F360 online check: ' + err);
							$s.loading = false;
						}
						if (data) {
							$s.loading = false;
							window.location.href = `#/f360/${data.AuditId}/evaluation-overview`;
						}
					});
				  }
				} else {
					var modaldisconnect = document.getElementById("disconnectModal");
					modaldisconnect.style.display = "block";
				}
			};

			$s.closeDownloadAndStart = function closeDownloadAndStart() {
				var modaldisconnect = document.getElementById("disconnectModal");
				modaldisconnect.style.display = "none";
			};

			$s.editReport = function editReport(report) {
				var deviceId = localStorage.getItem(config.deviceId);
			  if(_.isEqual($s.canEdit,true)){	
				
				 if(_.isEqual($s.deviceUpdateNeeded,true)){
				
				    self.syncedOn = moment(report.SyncedOn).toDate();	
				 
					self.editAuditId = report.AuditId;
					var modalEvaluationAnotherDevice = document.getElementById("evaluationAnotherDeviceModal");
					modalEvaluationAnotherDevice.style.display = "block";
				} else {
					window.location.href = `#/f360/${report.AuditId}/evaluation-overview`;
				}
		  	 }
			};
			$s.checkInOutAudit = function checkInOutAudit(report) {
                
				var checkedInOutAuditData = {
					herdId: _.get(MSF.getActiveHerd(),'herdId'),
					auditId: _.get(report,"AuditId"),
					checkedOutTo: JSON.stringify({}),
					authors: JSON.stringify(_.get(report,"Authors",[]))
				};
				
				var auditCheckedOutTo = _.get(report,'CheckedOutTo',{});
                // if auditCheckedOutTo is null then the audit is not checked out and we need to check it out
				if(_.isEmpty(auditCheckedOutTo)){
				   var checkedOutToObj = {
					   PersonId: self.personId,
					   FirstName: _.get(MSF,"cookies.user.FirstName"),
					   LastName: _.get(MSF,"cookies.user.LastName"),
					   Email: _.get(MSF,"cookies.user.Email")
				   };
				   _.set(checkedInOutAuditData,'checkedOutTo',JSON.stringify(checkedOutToObj));
				   _.set(report,'CheckedOutTo',checkedOutToObj);
				   _.set(report,'CheckedOutToDisplay',getCheckedOutToDisplay(checkedOutToObj));
				   // when checking out an audit we need to update the authors if this user has not checked out this audit before
				   var reportAuthors = _.get(report,'Authors',[]);
				   if(_.isEmpty(reportAuthors)){
					   var authorsArray = [];
					   var authorsObj = {
						   PersonId: self.personId,
						   FirstName: _.get(MSF,"cookies.user.FirstName"),
						   LastName: _.get(MSF,"cookies.user.LastName")
					   }
					   authorsArray.push(authorsObj);
					   _.set(checkedInOutAuditData,'authors',JSON.stringify(authorsArray));
					   _.set(report,'Authors',authorsArray);
					   _.set(report,'AuthorsDisplay',getAuthorsDisplay(authorsArray));
				   }else{
				
						// if the user has already checked out this audit then we don't want to add them to the authors array again
						var authorExists = _.find(reportAuthors,{PersonId: self.personId});
						if(_.isUndefined(authorExists)){
							var checkedOutToObj = {
								PersonId: self.personId,
								FirstName: _.get(MSF,"cookies.user.FirstName"),
								LastName: _.get(MSF,"cookies.user.LastName")
							};
							reportAuthors.push(checkedOutToObj);
						}
					   
					   
					   _.set(checkedInOutAuditData,'authors',JSON.stringify(reportAuthors));
					   _.set(report,'Authors',reportAuthors);
					   _.set(report,'AuthorsDisplay',getAuthorsDisplay(reportAuthors));
				   }
				}else{
					// if auditCheckedOutTo is not null then the audit is checked out and we need to check it in
					_.set(checkedInOutAuditData,'checkedOutTo',"{}");
					_.set(report,'CheckedOutTo',{});
					_.set(report,'CheckedOutToDisplay',getCheckedOutToDisplay({}));
				}

                 

				audit.checkInOutAudit(checkedInOutAuditData,function(err,data){
					if (err) {
						log.error(`error checking in or out the audit with an id of ${_.get(report,"AuditId")}: ` + err);
						MSF.notify.danger("There was an error checking in/out the audit. Please contact your Territory Manager.");
					}
					
				});
					

			}

			$s.continueWithAnotherDevice = function continueWithAnotherDevice() {
				log.info("checkSync: device data is older need to get data from server");
				audit.updateDeviceAuditData(_.get($s.activeAudit,'AuditId'), $s.performanceContext, function(err,data){
					if (err) {
						log.error('error updating device with server data: ' + err);
						$s.isDirty = true;
						audit.updateIsDirty(_.get($s.activeAudit,'AuditId'),$s.isDirty,function getIsDirtyUpdate(err, data){
							if (err) {
								log.error('error updateing isDirty flag: ' + err);
							}
						});
					}else{
						log.info("checkSync: update device complete");
						$s.deviceUpdateNeeded = false;
					    window.location.href = `#/f360/${self.editAuditId}/evaluation-overview`;
					}
					
					
				});

				
			};

			$s.cancelEvaluationAnotherDevice = function cancelEvaluationAnotherDevice() {
				var modalEvaluationAnotherDevice = document.getElementById("evaluationAnotherDeviceModal");
				modalEvaluationAnotherDevice.style.display = "none";
			};

			$s.deleteReport = function deleteReport(auditId) {
				
				    $s.toggleModal('deleteModal');
					self.deleteAuditId = auditId;
				
			};

			$s.onConfirmDeleteAudit = function onConfirmDeleteAudit() {
				$s.isDirty = true;
				audit.deleteAudit(self.deleteAuditId, function deleteAudit(err, data) {
					if (err) {
						log.error('error getting F360 online check: ' + err);
						$s.isDirty = false;
					}else{
						if (data) {

								// if the update was successfull and we are online we can then the data was synced and we can set isDirty false
								if($s.isOnline){
									$s.isDirty = false;
								}else{
									audit.updateIsDirty(self.deleteAuditId,$s.isDirty,function getIsDirtyUpdate(err, data){
										if (err) {
											log.error('error updateing isDirty flag: ' + err);
										}
									});
								}
							
								loadReportData();
							var modalDelete = document.getElementById("deleteModal");
							modalDelete.style.display = "none";
							$s.activeAudit = undefined;
                          if(!$s.isOnline){
							$s.$apply();
						  }
							 
						}
				}
				});
			};

			$s.cancelDelete = function cancelDelete() {
				$s.toggleModal('deleteModal');
			};
		

			$s.checkF360SyncStatus = function checkF360SyncStatus() {
				var syncStatusPromise = $q.defer();

				if ($s.isOnline) {
				      $s.canEdit = true; 
				
					  log.info(" F360 Dashboard : checkSync: Synch in Progress");
					   
                       audit.checkObjectStoresExist(constant.getList).then(function objectStoresExist(value){
						// if the object stores exist we don't want to recreate them all again 

						if(!_.isUndefined($s.activeAudit) && !_.isEmpty($s.activeAudit) && !_.isEqual($s.activeAudit,"")){
							var lastSyncedDate = "";
							var isDeviceDirty = false;

						log.info($s.activeAudit);	
						audit.getIndexDBListByHerdId(function getF360List(err, data){

							if(err){
								log.error("There was err in getting cached list : "+err);
							}

							var activeAuditListData = _.find(data,{AuditId: _.get($s.activeAudit,'AuditId')});
							// if this device cannot find the active audit in the indexedb we need to check this screen's report list
							if(_.isUndefined(activeAuditListData)){
							  
							  activeAuditListData = _.find(self.listReport,{AuditId: _.get($s.activeAudit,'AuditId')});
							  // if we find the active audit this way then this is a different device that needs to be synced 
							  // so we set lastSyncedDate and isDeviceDirty in a way that will trigger a device update logic. 
							  if(!_.isUndefined(activeAuditListData)){
									
								   if(!_.isNull(_.get(activeAuditListData,'SyncedOn',null))){
								    	lastSyncedDate = moment(new Date(null));
									    isDeviceDirty = true;
								   }else{

									// for now this trying to prevent a second device from updating an active audit that hasn't started yet.
									log.info("checkedSync: active audit found in self.listReport,but never started so ending sync");
							
									  $s.canEdit = false;
									  syncStatusPromise.resolve(true);
									  return syncStatusPromise.promise;
									 
								   }
								   
							  }else{
								  // unlikely to end up here, but code here just in case
								  log.info("checkedSync: $s.activeAudit exists , but cannot find audit record in indexedDB or SQL , end sync");
								
								$s.canEdit = false;
								syncStatusPromise.resolve(true);
								return syncStatusPromise.promise;
								
							  }
							     
							 }else{
								log.info("checkedSync: active audit found in indexedDB, getting its lastSycnedDate and isDeviceDirty");
								lastSyncedDate = _.get(activeAuditListData,'SyncedOn',null);
							
				              	isDeviceDirty = _.get(activeAuditListData,'IsDeviceDirty',false);
							 }
							 if(_.isEqual(lastSyncedDate,"")){
								lastSyncedDate = null;
							}
						    
						
								log.info("check Sync: calling getSyncStatus with lastSyncedDate: "+lastSyncedDate+" and isDeviceDirty: "+isDeviceDirty);
								perfMetricSvc.startTiming('Page:Fertility360ReportGetSyncStatus:Request');
								api.getSyncStatus(_.get($s.activeAudit,'AuditId',3),lastSyncedDate,isDeviceDirty, $s.performanceContext, function getF360SyncStatus(err, data) {
									perfMetricSvc.endTiming("page",'Page:Fertility360ReportGetSyncStatus:Request', $s.performanceContext);
									if (err) {
										self.isSync = false;
										log.error('error getting F360 online check: ' + err);
									}
									
									if (data) {
										self.isSync = true;
										var syncData = data;	
									
										if(!_.isUndefined(syncData)){
										
												if((_.isEqual(_.get(syncData,'ToUpdateServer'),true)) || (_.isEqual(_.get(syncData,'ToUpdateServer').toLowerCase(),"true"))){

													log.info("checkedSync: server needed updating");
													
													audit.updateServerAuditData(_.get($s.activeAudit,'AuditId'),function(err,data){
														if (err) {
															log.error('error updating server with device data: ' + err);
															$s.isDirty = true;
														}else{
															$s.isDirty = false;
														}

														log.info("update server complete");

														// we need to update the IsDeviceDirty flag of the audit in IndexDB
														audit.updateIsDirty(_.get($s.activeAudit,'AuditId'),$s.isDirty,function getIsDirtyUpdate(err, data){
															if (err) {
																log.error('error updateing isDirty flag: ' + err);
															}

															log.info("checkedSync: update IsDeviceDirty complete");

															// we need to call up the database version of SyncedOn because the update server proccess sets a more current SyncedOn on the server side
															audit.getListByHerdId(function getF360ListByHerdId(err, data) {
																if(err){
																	log.error("An error occured when getting the list of audits after updating isDirty flag : "+ err);						
																}
																var auditlistItem = _.find(data,{AuditId: _.get($s.activeAudit,'AuditId')});

																//if the audit was deleted ,the record won't be in IndexedDB and doesn't need SyncedOn updated
																if(!_.isUndefined(auditlistItem)){ 
																	audit.updateLastSyncedDate(_.get($s.activeAudit,'AuditId'),_.get(auditlistItem,'SyncedOn'),function getUpdateLastSyncDateData(err,data){
																		if (err) {
																			log.error('error updating server with device data: ' + err);
																		}
																		// if the audit has been published with this sync then we reset activeAudit 
																		if(!_.isNull(_.get($s.activeAudit,'PublishedOn',null))){
																			$s.activeAudit = undefined;
																		}
																		log.info("checkedSync: last synced date update complete , sync end");
																	
																		syncStatusPromise.resolve(true);
					
																	});	 
																}else{
																	log.info("checkedSync: audit was deleted . so no need to update last synced date. sync end ");
															
																	syncStatusPromise.resolve(true);
																}
				
															});
														});
														
													});
												}else{
												// the device's SyncedOn Date is older than the server's copy of the same property and the device needs updating
													log.info("checkSync: server is up to date , need to check if device needs updating");
														if((_.isEqual(_.get(syncData,'ToUpdateDevice'),true)) || (_.isEqual(_.get(syncData,'ToUpdateDevice').toLowerCase(),"true"))){
															log.info("checkSync: device needs updating , setting device update flag true , sync end");
																$s.deviceUpdateNeeded = true;
																										
																syncStatusPromise.resolve(true);
														}else{
															log.info("checkSync: no server update needed , sync end");
													
															syncStatusPromise.resolve(true);
														}
													
												}
									
											
											} else {
												log.info("checkedSync: no getSyncedStatus data returned , sync end");
											
												self.isSync = false;
												syncStatusPromise.resolve(true);
											
											}
									}else{
										log.info("checkedSync: no sync data returned. cannot continue with sync , sync end");
									
										syncStatusPromise.resolve(true);
										
									}	
							});
					
						});

													

					}else{
                    	
							syncStatusPromise.resolve(true);
         			}

					},function objectStoresDoNotExist(value){
						
						log.info("checkSync: object stores didn't exist yet, sync will end when the they are initialized and a checSync is performed.");
					
						syncStatusPromise.resolve(true);
						
				   });

				} else {
					self.isSync = false;
					
				    syncStatusPromise.resolve(true);
		
			}
						
			return syncStatusPromise.promise;
			};

	

			
			$s.syncingBackOnline = false;
			
			deregOnlineCheckWatch =	$s.$on('online:change',function(event,onLineChange){
			
				   var onLineValue = _.get(onLineChange,'value');
				   var isOnlineOldValue =  angular.copy($s.isOnline);
				   $s.isOnline = onLineValue; 
				   // if the device was previously offline and now back online
				// we need to see if we will run checkF360SyncStatus
				if(isOnlineOldValue === false && onLineValue === true){
                     if($s.syncingBackOnline === false){
						 $s.syncingBackOnline = true;
						 $s.syncInProgress = true;
						 $s.checkF360SyncStatus().then(function(){
							$s.syncingBackOnline = false;
							$s.syncInProgress = false;
						 });
					 } 
				}
				
			});

			
		

			
			deregOnFarmChange =	$s.$on('farm:changed',function(){
			
				//checkPermissions();
				// if($s.pageLoaded === true){
			    // 	audit.getList(self.personId);
				// }
			});

            deregObjectStoresInitialized = $s.$on('auditService:objectStores-initialized',function onObjectStoresExist(){
				  $s.syncInProgress = true;
                  $s.checkF360SyncStatus().then(function(){
					$s.syncInProgress = false;
				  });
			});

			deregPageLoad = $s.$watchGroup(['herdFertilityProgramLoaded','listLoaded','currentHerdLoaded'],function(stateArray){
			   if(_.every(stateArray,function(value){ return _.isEqual(value,true);})){
				   $s.pageLoaded = true;
			   }else{
				  $s.pageLoaded = false;
			   }
		  });


		  function loadReport(){
			return $q((resolve, reject) => {
				$q.all([
					loadReportData(),
					loadCurrentHerd(),
					getHerdFertilityProgramsByHerdId()
				]).then(() => {
					console.log('All promises resolved');
					resolve();
				})
			});
		  }

		  $s.$on("$destroy", function() {
			
			log.info("dashboard destroy called");
		
		
		
			deregOnFarmChange();
			deregOnHerdChange();
			deregPageLoad();
			deregObjectStoresInitialized();
			deregOnlineCheckWatch();
			$s.performanceContext = null;
		});



			MSF.ready(function onMsfReady() {
				$s.performanceContext = perfContextSvc.createPerformanceContext(_.get(MSF.getActiveHerd(),'herdId',null));
				audit.getList(self.personId, $s.performanceContext);
				$s.codeFile = _.cloneDeep(_.get(MSF,'lists.codeFile',[]));
				var currentAuditApiVersionJsonArray = [];
				try {
					 var currentAuditApiVersionJsonArray =  JSON.parse(_.get(_.find($s.codeFile,{codeType: "CURRENTAPIVERSIONS",code:"AUDIT"}),'detailsJson'));
				} catch (error) {
					log.error(`error parsing CURRENTAPIVERSIONS code file for AUDIT: ${error}`);
				}
				$s.currentAuditApiVersion = _.get(currentAuditApiVersionJsonArray,'[0].value');
				checkPrePopulatedDataStatus();
				checkPermissions();
				loadCurrentFarm();

				// loadReportData();
			
				// loadCurrentHerd();
				// getHerdFertilityProgramsByHerdId();
				
				perfMetricSvc.startTiming("Page:Fertility360Report:Render");
				loadReport().then(() => {
					perfMetricSvc.markPageReady("Page:Fertility360Report:Render", $s.performanceContext);
				});

				deregOnHerdChange = $s.$on('herd:changed', function(){
					checkPrePopulatedDataStatus();
					checkPermissions();
					loadCurrentFarm();
					$s.territoryManager = MSF.getActiveFarmTerritoryManager(); 
					$s.performanceContext = perfContextSvc.createPerformanceContext(_.get(MSF.getActiveHerd(),'herdId',null));
					if($s.pageLoaded === true){
			    		audit.getList(self.personId, $s.performanceContext);
					}
					
					// loadReportData();
				
					// loadCurrentHerd();
					// getHerdFertilityProgramsByHerdId();
					perfMetricSvc.startTiming("Page:Fertility360ReportOnHerdChange:Render");
					
					loadReport().then(() => {
						perfMetricSvc.markPageReady("Page:Fertility360ReportOnHerdChange:Render", $s.performanceContext);
					});
					
				
					
				});
			});

			

	

		 
		}
	]);
})();
